import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "fr");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
    document.documentElement.lang = l;
  };
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const t = translations[lang] || translations.fr;
  return <LangCtx.Provider value={{ lang, setLang, t, langs: LANGS }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
